import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

function DeleteDraft({ itemId }) {
  const { deleteData } = CashierApi();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id) => deleteData(`orders/delete/`, id),
    onSuccess: async () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      await queryClient.invalidateQueries({ queryKey: ["draft"] });
    },
  });
  const handleDelete = (event, id) => {
    event.stopPropagation();
    mutation.mutate(id);
  };
  return (
    <button onClick={(event) => handleDelete(event, itemId)}>
      <DeleteIcon className="text-red-500 cursor-pointer" />
    </button>
  );
}

export default DeleteDraft;
